import api from './api';
import type { Paginated, Parcel, ParcelEvent, ParcelRevenueSummary, ParcelStatus } from '../types/api';

export async function listParcels() {
  const { data } = await api.get<Paginated<Parcel> | Parcel[]>('/parcels/');
  return Array.isArray(data) ? data : data.results;
}

export async function createParcel(payload: Partial<Parcel>) {
  const { data } = await api.post<Parcel>('/parcels/', payload);
  return data;
}

export async function updateParcel(id: number, payload: Partial<Parcel>) {
  const { data } = await api.patch<Parcel>(`/parcels/${id}/`, payload);
  return data;
}

export async function deleteParcel(id: number) {
  await api.delete(`/parcels/${id}/`);
}

export async function setParcelStatus(id: number, status: ParcelStatus) {
  await api.post(`/parcels/${id}/update_status/`, { status });
}

export async function getParcelEvents(id: number): Promise<ParcelEvent[]> {
  const { data } = await api.get<ParcelEvent[]>(`/parcels/${id}/events/`);
  return data;
}

export async function getParcelRevenue(params: { start: string; end: string }): Promise<ParcelRevenueSummary> {
  const { data } = await api.get<ParcelRevenueSummary>('/parcels/revenue_summary/', { params });
  return data;
}

export async function downloadParcelRevenueCsv(params: { start: string; end: string }): Promise<void> {
  const res = await api.get('/parcels/revenue_summary/', {
    params: { ...params, export: 'csv' }, responseType: 'blob',
  });
  const url = window.URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `parcel-revenue-${params.start}_${params.end}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
